import { render, staticRenderFns } from "./tuzhuanglinxi.vue?vue&type=template&id=f83ae4c6&scoped=true&"
import script from "./tuzhuanglinxi.vue?vue&type=script&lang=js&"
export * from "./tuzhuanglinxi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f83ae4c6",
  null
  
)

export default component.exports